export const usd = (microUsd: number, digits = 4) => `$${(microUsd / 1e6).toFixed(digits)}`;

/** Relative time for both directions: "5 min ago" / "in 29 days". */
export const when = (iso: string) => {
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  const abs = Math.abs(diff);
  const unit =
    abs < 60
      ? 'just now'
      : abs < 3600
        ? `${Math.floor(abs / 60)} min`
        : abs < 86400
          ? `${Math.floor(abs / 3600)} h`
          : abs < 86400 * 60
            ? `${Math.floor(abs / 86400)} days`
            : null;
  if (unit === null) return d.toLocaleDateString();
  if (unit === 'just now') return unit;
  return diff >= 0 ? `${unit} ago` : `in ${unit}`;
};

export const short = (s: string, n = 120) => (s.length > n ? `${s.slice(0, n)}…` : s);

export const errorMessage = (e: unknown) => (e instanceof Error ? e.message : String(e));
